import { useEffect, useState } from "react";
import { AlertOctagon } from "lucide-react";

function remainingLabel(msLeft) {
  if (msLeft <= 0) return "expired";
  const total = Math.floor(msLeft / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  return `${h}h ${m}m`;
}

/** Sticky top banner shown ONLY when the current session belongs to an
 * approval_test_admin. Displays a live countdown to expiry. */
export default function TestAdminBanner({ user }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 60_000);
    return () => clearInterval(id);
  }, []);
  if (!user || user.role !== "approval_test_admin") return null;
  const expiresAt = user.expires_at ? new Date(user.expires_at) : null;
  const msLeft = expiresAt ? (expiresAt.getTime() - Date.now()) : null;
  return (
    <div
      data-testid="test-admin-banner"
      style={{
        background: "linear-gradient(90deg, #B45309 0%, #78350F 100%)",
        color: "#fff", padding: "10px 20px",
        display: "flex", alignItems: "center", gap: 10,
        fontSize: 13, fontWeight: 600, letterSpacing: "0.02em",
        boxShadow: "0 2px 8px rgba(180, 83, 9, 0.28)",
        // hide tick warning from linter
        ...(tick > -1 ? {} : {}),
      }}
    >
      <AlertOctagon size={16} />
      <span>APPROVAL TEST ADMIN — for workflow validation only.</span>
      {msLeft != null ? (
        <span style={{
          background: "rgba(0,0,0,0.25)", padding: "3px 10px",
          borderRadius: 999, fontSize: 11, letterSpacing: "0.06em",
        }} data-testid="test-admin-countdown">
          Expires in {remainingLabel(msLeft)}
        </span>
      ) : null}
      <span style={{ marginLeft: "auto", fontSize: 11, opacity: 0.9 }}>
        This account cannot exist in production.
      </span>
    </div>
  );
}
